var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3479 18.8622H22.7215C21.9031 18.8622 21.1953 18.3087 21.0185 17.6122L20.0444 9.84773C19.7471 6.92311 17.8588 4.4303 15.1636 3.33319C15.032 1.82137 13.7606 0.630859 12.2148 0.630859C10.672 0.630859 9.40095 1.81712 9.26491 3.32471C6.564 4.39064 4.64844 6.84243 4.31342 9.72881L3.34781 17.5145C3.15259 18.3087 2.44479 18.8622 1.62646 18.8622H0V23.3934H8.33059C8.71969 25.1601 10.2897 26.4837 12.174 26.4837C14.0579 26.4837 15.6279 25.1601 16.017 23.3934H24.3479V18.8622ZM22.6493 21.6932H1.69853V20.5607C3.26854 20.5281 4.61882 19.4509 5.0154 17.823L6.00039 9.93106C6.28235 7.49343 8.00234 5.45217 10.3818 4.73305L11.0869 4.51929L10.9747 3.79028C10.9651 3.72516 10.9522 3.66004 10.9522 3.59209C10.9522 2.89561 11.5185 2.32939 12.2148 2.32939C12.9103 2.32939 13.4776 2.89561 13.4776 3.59209C13.4776 3.66144 13.4633 3.72656 13.4535 3.7931L13.3433 4.51362L14.0381 4.73164C16.4095 5.47763 18.1026 7.55289 18.3556 10.0387L19.3495 17.9206C19.7287 19.4523 21.0793 20.5281 22.6493 20.5607V21.6932Z",
    fill: "#024BD5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.1bf5748b.svg";
export { ForwardRef as ReactComponent };